<template>
  <div ref="stripeAccountContainer">
    <div class="page-header bordered">
      <h1>Stripe Account</h1>
    </div>

    <div v-if="stripeAccount.status === 'connected'" class="error-template text-center">
      <i v-if="stripeAccount.charges_enabled"
        class="fa fa-check fa-5x text-success animated zoomIn" />
      <i v-else class="fa fa-exclamation-triangle fa-5x text-warning animated zoomIn" />

      <br/><br/>

      <h3 class="centered">
        <span>Stripe Account Connected</span>
      </h3>

      <div v-if="stripeAccount.charges_enabled">
        <div class="main-title-description">
          Your stripe account was connected successfully and is ready to receive charges.
        </div>
        <div class="centered">
          <a class="btn btn-lg btn-primary" @click="disconnectStripeAccount()">
            Disconnect Stripe Account
          </a>
        </div>
      </div>
      <div v-else>
        <div class="main-title-description">
          Your stripe account was connected successfully, but is not ready to receive charges.
        </div>
        <div class="main-title-description">
          You need to provide Stripe more information about your business.
        </div>
      </div>
    </div>

    <div v-if="stripeAccount.status === 'pending'" class="error-template text-center">
      <i class="fa fa-exclamation-triangle fa-5x text-warning animated zoomIn" />
      <br/><br/>
      <h3 class="centered">
        <span>Stripe Account Not Connected</span>
      </h3>
      <div class="main-title-description">
        Please, connect your stripe account to enable event creation!
      </div>

      <div class="main-title-description">
        <a :href="stripeAccount.connect_url" class="btn btn-lg btn-primary">
          Connect Stripe Account &nbsp;
          <i class="fa fa-external-link" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stripeAccount',
  data: function () {
    return {
      scope: this.$route.query.scope || null,
      code: this.$route.query.code || null,
      state: this.$route.query.state || null,
      stripeAccount: {}
    }
  },
  created: function () {
    this.getStripeAccountInfo()
  },
  methods: {
    getStripeAccountInfo () {
      var self = this
      var loader = this.$loading.show()
      var stripeAccountReference = this.$localStorage.get('user_stripe_acocunt_reference')

      this.$http.get('/stripe_accounts/' + stripeAccountReference).then(function (response) {
        self.stripeAccount = response.data
        self.updateStripeAccountData()
      }).finally(function () {
        loader.hide()
      })
    },
    updateStripeAccountData () {
      if (this.scope !== null && this.code !== null && this.state !== null &&
        this.stripeAccount.status !== 'connected') {
        let loader = this.$loading.show({
          container: this.$refs.stripeAccountContainer
        })
        var self = this

        this.$http.put('/stripe_accounts/' + this.stripeAccount.id,
          { scope: this.scope, code: this.code, state: this.state }).then(function (response) {
          self.stripeAccount = response.data

          // Update user type after connect stripe account
          self.$store.commit('updateUserType', self.stripeAccount.user.user_type)
          self.$localStorage.set('user_type', self.stripeAccount.user.user_type)

          self.$swal({
            title: 'Stripe Account connected!',
            type: 'success'
          })
        }).catch(function (error) {
          if (error) {
            self.$swal({
              title: 'Error connecting Stripe Account',
              type: 'error'
            })
          }
        }).finally(function () {
          loader.hide()
        })
      }
    },
    disconnectStripeAccount () {
      const self = this

      self.$swal({
        title: 'Confirm Stripe Account disconnection?',
        text: "You won't be able to charge attendees",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, disconnect it!'
      }).then((result) => {
        if (result.value) {
          var loader = self.$loading.show()

          self.$http.delete('/stripe_accounts/' + this.stripeAccount.id).then(function (response) {
            self.stripeAccount = response.data

            // Update user type after connect stripe account
            self.$store.commit('updateUserType', self.stripeAccount.user.user_type)
            self.$localStorage.set('user_type', self.stripeAccount.user.user_type)

            self.$swal({
              title: 'Stripe Account disconected!',
              type: 'success'
            })
          }).catch(function (error) {
            if (error) {
              const data = error.response.data

              self.$swal({
                title: 'Error disconnecting Stripe Account!',
                text: data.error,
                type: 'error'
              })
            }
          }).finally(function () {
            loader.hide()
          })
        }
      })
    }
  }
}
</script>
